import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextH4 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M5 6C5.55228 6 6 6.44772 6 7V13.5H17V7C17 6.44772 17.4477 6 18 6C18.5523 6 19 6.44772 19 7V22C19 22.5523 18.5523 23 18 23C17.4477 23 17 22.5523 17 22V15.5H6V22C6 22.5523 5.55228 23 5 23C4.44772 23 4 22.5523 4 22V7C4 6.44772 4.44772 6 5 6Z" }), /* @__PURE__ */ _jsx("path", { d: "M26.8328 11.557C27.3536 11.7408 27.6268 12.312 27.443 12.8328L24.9134 20H28.5V17C28.5 16.4477 28.9477 16 29.5 16C30.0523 16 30.5 16.4477 30.5 17V20.996L30.5 21L30.5 21.0039V25C30.5 25.5523 30.0523 26 29.5 26C28.9477 26 28.5 25.5523 28.5 25V22H23.5C23.1755 22 22.8711 21.8425 22.6837 21.5776C22.4962 21.3126 22.449 20.9732 22.557 20.6672L25.557 12.1672C25.7408 11.6464 26.312 11.3732 26.8328 11.557Z" })]
});
export default SvgTextH4;
